import React from 'react';
import PropTypes from 'prop-types';
import { CORE_FONTS, PRO_FONTS } from '../../constants/fonts';
import FontPreview from './FontPreview';
import './FontSelector.css';

/**
 * FontSelector - Choose font for captions
 *
 * Shows Core fonts (always available) and Pro fonts (locked without subscription)
 */
function FontSelector({ selectedFont, onFontChange, hasProAccess }) {
  return (
    <div className="font-selector">
      <div className="font-section">
        <h3 className="font-section-title">Core Fonts</h3>
        <div className="font-grid">
          {CORE_FONTS.map(font => (
            <FontPreview
              key={font.id}
              font={font}
              isSelected={selectedFont === font.id}
              isLocked={false}
              onClick={onFontChange}
            />
          ))}
        </div>
      </div>

      <div className="font-section">
        <h3 className="font-section-title">
          Pro Fonts
          {!hasProAccess && (
            <span className="pro-badge">
              <i className="fas fa-crown"></i> Pro
            </span>
          )}
        </h3>
        <div className="font-grid">
          {PRO_FONTS.map(font => (
            <FontPreview
              key={font.id}
              font={font}
              isSelected={selectedFont === font.id}
              isLocked={!hasProAccess}
              onClick={onFontChange}
            />
          ))}
        </div>
        {!hasProAccess && (
          <div className="font-upgrade-prompt">
            <p>Unlock 8 premium fonts with Pro</p>
            <button
              className="btn-upgrade"
              onClick={() => window.location.href = '/subscription'}
            >
              Upgrade to Pro
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

FontSelector.propTypes = {
  selectedFont: PropTypes.string.isRequired,
  onFontChange: PropTypes.func.isRequired,
  hasProAccess: PropTypes.bool.isRequired
};

export default FontSelector;
